import { createContext } from "react";
let emailContext=createContext()

export default emailContext;